module.exports = __webpack_public_path__ + "img/shape1.0839d0a0.svg";